<template>
  <footer class="main-footer">

  </footer>
</template>

<script>
export default {

}
</script>

<style>

</style>